import iconSrc from '@wwe-portal/ui/assets/images/common/invalid.webp';

export const CouponInvalidDialogHead = () => {
  return (
    <div className="relative flex h-full w-full items-center justify-center">
      <div className="from-bgColor45 to-bgColor46 rounded-full bg-gradient-to-b p-1">
        <div className="bg-back200 rounded-full p-2">
          <img alt="success" height={76} src={iconSrc} width={76} />
        </div>
      </div>
    </div>
  );
};
